import { API_BASE_URL, ENDPOINTS, REQUEST_CONFIG } from './chatConfig';

/**
 * API методы для работы с агентами поддержки
 */

/**
 * Авторизация агента
 * @param {string} email - Email агента
 * @param {string} password - Пароль
 * @returns {Promise<Object>} Токен и данные агента
 */
export const loginAgent = async (email, password) => {
  try {
    const response = await fetch(`${API_BASE_URL}${ENDPOINTS.AUTH_LOGIN}`, {
      method: 'POST',
      ...REQUEST_CONFIG,
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    if (data.success && data.data.token) {
      // Сохраняем токен в localStorage
      localStorage.setItem('agentToken', data.data.token);
      localStorage.setItem('agentData', JSON.stringify(data.data.agent));
    }
    
    return data.data;
  } catch (error) {
    console.error('Error logging in agent:', error);
    throw error;
  }
};

/**
 * Получение информации о текущем агенте
 * @returns {Promise<Object>} Данные агента
 */
export const getAgentInfo = async () => {
  try {
    const token = localStorage.getItem('agentToken');
    
    if (!token) {
      throw new Error('No token found');
    }

    const response = await fetch(`${API_BASE_URL}${ENDPOINTS.AUTH_ME}`, {
      method: 'GET',
      headers: {
        ...REQUEST_CONFIG.headers,
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error('Error fetching agent info:', error);
    throw error;
  }
};

/**
 * Выход агента из системы
 */
export const logoutAgent = () => {
  localStorage.removeItem('agentToken');
  localStorage.removeItem('agentData');
};

/**
 * Проверка авторизации агента
 * @returns {boolean}
 */
export const isAgentAuthenticated = () => {
  return !!localStorage.getItem('agentToken');
};

/**
 * Получение токена агента
 * @returns {string|null}
 */
export const getAgentToken = () => {
  return localStorage.getItem('agentToken');
};
